"use client";

import useNextRouter from '@/hooks/useNextRouter';
import { useOutsideClick } from "@/hooks/useOutsideClick";
import useSetSearchParams from '@/hooks/useSetSearchParams';
import useSizeController from '@/hooks/useSizeController';
import { dispatchRouteChangeEvent } from '@/utils/routeEvents';
import { deslugify } from '@/utils/slugify';
import { faMoon, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, useEffect, useState } from "react";
import slugify from 'slugify';
import SearchInput from './SearchInput';

import dynamic from 'next/dynamic';

const PassModal = dynamic(() => import('../PassModal'))


import FlightSearch from '@/app/(pages)/(homePage)/components/searchbar-sections/FlightSearch';
import { useHomeSectionsStore } from '@/core/stores/homeSections';
import useWebbedStore from '@/core/stores/webbed';
import { useSubmitHotelSearch } from '@/hooks/useSubmitHotelSearch';
import { calculateDateDistance } from '@/utils/dateOperators/calculateDateDistance';
import { format } from 'date-fns';
import { CalendarMinimalistic, MapPoint, UsersGroupRounded } from 'solar-icon-set';
import Button, { ButtonColors } from './Button';

import { usePathname } from 'next/navigation';


const tabColors = {
  itinerary: 'border-gray-300',
  hotels: ' border-gray-300',
  cities: 'border-gray-300',
}

type TabType = 'hotels' | 'itinerary' | 'cities' | 'attractions' | 'flights';

interface SearchBarProps {
  wpBaseUrl?: string,
  isLanding?: boolean,
  buttonColor?: ButtonColors,
  image?: ReactNode,
  single?: boolean,
  goTo?: string,
  toMapPage?: boolean
  onClose?: () => void
  tabs?: ReactNode
}

const DatePickerModal = dynamic(() =>
  import('./DatePicker').then((mod) => mod.DatePickerModal)
)
const TripMaker = dynamic(() => import('@/app/(pages)/(homePage)/components/searchbar-sections/TripMaker'))
const MobileSearchInput = dynamic(() => import('@/app/(pages)/(homePage)/components/mobileSearchInput'))
const PassengerModal = dynamic(() => import('@/app/(pages)/(activites)/activities/[country]/[city]/[activityId]/(detailPage)/NewComponents/PassengerModal'))
const Modal = dynamic(() => import('./Modal'))

const isTabType = (tab: string | null | undefined): tab is TabType =>
  tab !== null && tab !== undefined && ['hotels', 'itinerary', 'cities', 'attractions', 'flights'].includes(tab);

const SearchBar = ({ buttonColor = 'primary',
  isLanding = false,
  image, single, goTo, onClose, toMapPage = false,
  tabs
}:
  SearchBarProps) => {
  const { push } = useNextRouter();

  const [errors, setErrors] = useState({
    city: "",
    date: "",
    passenger: "",
    country: ''
  });

  const [selectedCity, setSelectedCity] = useState({
    name: "",
    id: "",
    country: "",
  });

  const [submitType, setSubmitType] = useState("hotels");

  const { values, handleValueChange, allPassengers, isSubmiting, setIsSubmiting
    , newRoomData, setNewRoomData, encodePassengerToSlug, hasDateChanged, hasPassChanged,
    checkInTime, checkOutTime
  } = useSubmitHotelSearch()

  const { innerWidth, isLarge, isSmall } = useSizeController()

  const { params: { std, end, passenger, placeId, prompt, promptText }, setSearchParam,
    mainParams: { country: countryParam } } = useSetSearchParams(goTo);

  const [tripType, setTripType] = useState<string>('leisure')

  const { isSearchingHotels, setIsSearchingHotels } = useWebbedStore()

  useEffect(() => {
    if ((countryParam?.length > 0)) {
      setSelectedCity({
        name: (deslugify(countryParam?.[1]?.toLowerCase() || countryParam?.[0]?.toLowerCase() || '')) as string,
        id: placeId || '' as string,
        country: countryParam?.[1] ? countryParam?.[0]?.toLowerCase() : '',
      });
    }
  }, [passenger, std, end, placeId, countryParam]);

  const onSubmit = async () => {
    let NewErrors = {
      city: "",
      date: "",
      country: '',
      passenger: "",
    };
    if (!selectedCity.id) {
      NewErrors.city = "Please select a city";
      setErrors(NewErrors);
      return
    }
    if (!values || !values[0] || !values[1]) {
      NewErrors.date = "Please select a date";
      setErrors(NewErrors);
      return
    }

    if (selectedCity.id && values && values[1] && values[0] && tripType) {

      setIsSubmiting(true);
      push(`/itineraries/generate?city=${slugify(selectedCity.name)}&placeId=${selectedCity.id}&start=${values[0].toLocaleDateString('sv-SE')}&end=${values[1].toLocaleDateString('sv-SE')}&type=${tripType}`)

    } else {
      setIsSubmiting(false);
    }
  };
  function onSubmitAttractions() {

  }
  const onSubmitCities = async () => {
    let NewErrors = {
      city: "",
      date: "",
      passenger: "",
      country: '',
    };

    if (selectedCity.id) {
      setIsSubmiting(true);
      push(`/cities/${selectedCity.name}`)
    } else {
      NewErrors.city = "Please select a city";
      setErrors(NewErrors);
      setIsSubmiting(false);
      return
    }
  };

  const pathName = usePathname()

  let activeTab: TabType = 'hotels';

  const { mobileActiveSection = 'hotels', setMobileActiveSection } = useHomeSectionsStore();
  useEffect(() => {
    setMobileActiveSection('hotels')
  }, [pathName])

  activeTab = isTabType(mobileActiveSection) ? mobileActiveSection : 'hotels';

  const onSubmitHotelSearch = async () => {
    let hasError = false;

    let NewErrors = {
      city: "",
      date: "",
      passenger: "",
      country: '',
    };
    if (!selectedCity.name) {
      NewErrors.city = "Please select a city";
      hasError = true;
    }
    if (!values || !values[0] || !values[1]) {
      NewErrors.date = "Please select a date";
      hasError = true;
    }

    // if (selectedCity.name?.toLowerCase() === countryParam?.[0]?.toLowerCase()) {
    //   return
    // }

    // if (
    //   selectedCity?.name?.toLowerCase() === countryParam?.[1]?.toLowerCase() &&
    //   selectedCity?.country?.toLowerCase() === countryParam?.[0]?.toLowerCase()) {
    //   return
    // }

    if (allPassengers < 1) {
      NewErrors.passenger = "Please select at least one passenger";
      hasError = true;
    }

    if (!hasDateChanged && !hasPassChanged) {
      if (
        (selectedCity.name?.toLowerCase() === countryParam?.[1]?.toLowerCase()
          && selectedCity.country === countryParam?.[0]?.toLowerCase()) ||
        selectedCity.name?.toLowerCase() === countryParam?.[0]?.toLowerCase()
      ) {

        return
      }
    }

    if (hasError) {
      setErrors(NewErrors);
      return;
    }
    setIsSubmiting(true);
    setIsSearchingHotels(true)
    goTo && dispatchRouteChangeEvent('start')
    setSearchParam([
      // { city: slugify(selectedCity.name) },
      // { placeId: selectedCity.id },
      ...(promptText ? [{ promptText: '' }] : []),
      ...(prompt ? [{ prompt: '' }] : []),
      {
        passenger: encodePassengerToSlug,
      },
      { std: values[0] ? format(values[0], "yyyy-MM-dd") || "" : "" },
      { end: values?.[1] ? format(values[1], "yyyy-MM-dd") : "" },

    ], true, `/hotels/${toMapPage ? 'map/' : ''}${slugify(selectedCity.country?.toLowerCase())}/${slugify(selectedCity.name?.toLowerCase())}`, false);
    !goTo && setIsSubmiting(false);

    if (onClose) {
      onClose()
    }
  };

  const [showPassModal, setShowPassModal] = useState(false);


  const [showTripTypes, setShowTripTypes] = useState(false)

  const tripTypesRef = useOutsideClick(() => { setShowTripTypes(false) })

  const passModal = useOutsideClick(() => {
    innerWidth > 1024 && setShowPassModal(false);
  });

  const searchTypeMap = {
    hotels: 'webbed',
    itinerary: 'google',
    attractions: 'attractions',
    default: 'google'
  } as const;

  const searchType = searchTypeMap[activeTab as keyof typeof searchTypeMap] || searchTypeMap.default;
  console.log({ activeTab });

  return (
    <>

      <div className="items-stretch relative z-50 justify-start flex w-full  flex-col ">
        {image}
        {tabs}
        <div className={`${tabColors[activeTab as keyof typeof tabColors]}
        ${isLanding ? 'hidden' : ' md:grid'}
          ${single ? 'rounded-3xl' : 'rounded-tl-none rounded-3xl md:rounded-tr-3xl rounded-t-none'}
              px-2 md:py-4  md:px-3 z-10 items-center md:grid 
             ${activeTab === 'itinerary' ? 'md:bg-white md:shadow-md' : 'bg-white shadow-md'}
             grid-cols-[repeat(3,_1fr),_auto]`}>
          {activeTab === 'itinerary' ? <>

            <TripMaker />
          </> : activeTab === 'flights' ?
            <FlightSearch />
            : <>
              <div className={`${activeTab === 'cities' || activeTab === 'attractions' ? 'col-span-3 border-t' : 'border-y '}
                             ${single ? 'border-t-0' : ''}
              py-1.5 md:border-y-0 border-gray-200 w-full`}>
                <div className={'grid grid-cols-[24px,_1fr] gap-4 items-center py-2 '}>
                  <MapPoint color='#4b5563' size={36} className='w-8 text-gray-600 justify-self-center pl-3' />
                  <div className={`${activeTab === 'cities' || activeTab === 'attractions' ? '' : 'md:border-r'} flex flex-col relative `}>
                    <span className={`${errors.city ? 'text-rose-500 font-semibold bg-rose-50 px-1 rounded w-fit' :
                      ' text-gray-500'}
                     text-xs hidden md:block font-normal`}>
                      Where to
                    </span>

                    <MobileSearchInput
                      isHotelSearch={goTo === '/hotels/search'}
                      onFocus={() => setErrors(s => ({ ...errors, city: '' }))}
                      hasError={!!errors.city}
                      setSelectedCity={setSelectedCity}
                      selectedCity={selectedCity}
                    />
                    <div className='hidden md:block'>
                      <SearchInput type={searchType}
                        onFocus={() => setErrors(s => ({ ...errors, city: '' }))}
                        hasError={!!errors.city}
                        setSelectedCity={setSelectedCity} selectedCity={selectedCity} />
                    </div>
                  </div>
                </div>
              </div>

              {(activeTab === 'hotels') &&
                <div className='py-1.5 md:py-0 md:pl-0 md:col-span-2 w-full'>
                  <div className='grid grid-cols-2'>
                    {(activeTab === 'hotels' || activeTab === 'itinerary') &&
                      <DatePickerModal
                        preventAutoClose
                        showOneMonth={!isLarge}
                        values={{ startDate: values[0], endDate: values[1] }}
                        buttonProps={{ className: 'md:border-r flex relative py-2.5 md:py-0 col-span-2 gap-1 md:col-span-1 md:justify-between px-2 lg:px-4 items-start ' }}
                        onChange={handleValueChange}
                        applyButton={
                          <div className='fixed w-full left-0 border-t bottom-0 p-4 bg-white'>
                            <div className='flex items-center justify-between'>
                              <div className='flex flex-col gap-1'>
                                <span className='text-gray-600 font-semibold'>Check-in</span>
                                {values[0] && <p dir=''
                                  className='flex items-center gap-1  md:font-bold text-gray-700 text-sm text-left'>
                                  <span className="">
                                    {checkInTime(true)}
                                  </span>

                                </p>}
                              </div>
                              <div className='flex flex-col gap-1'>
                                <span className='text-gray-600 font-semibold'>Check-out</span>
                                {values[1] && <p dir=''
                                  className='flex items-center gap-1  md:font-bold text-gray-700 text-sm text-left'>
                                  <span className="">
                                    {checkOutTime(true)}
                                  </span>

                                </p>}
                              </div>
                            </div>
                            <Button className='w-full mt-4' radius='rounded-full' color='secondary'>
                              Confirm
                            </Button>
                          </div>
                        }
                      >

                        <div className='flex items-center h-full gap-4'>
                          <CalendarMinimalistic className='min-[810px]:!inline-block !hidden lg:w-8 text-gray-600' color='#4b5563' size={24} />
                          <div className='flex flex-col justify-center  h-full'>
                            <span className='md:block hidden text-gray-500 font-normal text-xs'>Check in</span>
                            <div>

                              <button
                                className='flex relative items-center gap-1 '>
                                {values[0] && <p dir=''
                                  className='flex items-center gap-1  md:font-bold text-gray-700 text-sm text-left'>
                                  <span className="">
                                    {checkInTime(true)}
                                  </span>

                                </p>}
                              </button>

                            </div>
                          </div>
                        </div>
                        <span className='md:hidden'>-</span>
                        <div className='hidden md:flex lg:hidden xl:flex h-full items-center gap-1 text-gray-600 text-[10px] justify-center'>
                          <FontAwesomeIcon icon={faMoon} />
                          {values[0] && values[1] && <span>{
                            calculateDateDistance(format(values[0], "yyyy-MM-dd"), format(values[1], "yyyy-MM-dd"))}{' '}
                            Night{calculateDateDistance(format(values[0], "yyyy-MM-dd"), format(values[1], "yyyy-MM-dd")) > 1 && 's'}
                          </span>}
                        </div>
                        <div className='flex flex-col justify-center h-full'>
                          <span className='text-gray-500 md:block hidden font-normal text-xs'><span className='hidden lg:inline'>Check</span>  out</span>
                          <div>
                            <button
                              className='flex relative items-center gap-1 '>
                              {values[0] && <p dir=''
                                className='flex items-center gap-1  md:font-bold text-gray-700 text-sm text-left'>
                                <span className="">
                                  {checkOutTime(true)}
                                </span>
                              </p>}
                            </button>

                          </div>

                        </div>
                      </DatePickerModal>
                    }
                    {activeTab === 'hotels' &&
                      <div ref={passModal}
                        className='pl-2 pt-4 mt-1.5 md:mt-0 md:pt-0 border-t md:border-t-0 lg:pl-4 
                               col-span-2 md:col-span-1 flex items-center gap-4'>

                        <UsersGroupRounded color='#4b5563' className='w-8 text-gray-600' size={24} />
                        <div ref={passModal} className='flex flex-col relative gap-0.5 items-start '>
                          <span className='text-gray-500 font-normal text-xs'>Traveler(s)</span>
                          <div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation()
                                setShowPassModal(true)
                              }}
                              className='flex items-center gap-1 font-bold text-gray-700 text-left text-xs sm:text-sm'>
                              {allPassengers} Traveler(s), {newRoomData.length} Room(s)
                            </button>
                          </div>
                          {
                            !isSmall ? (
                              <PassModal
                                setRoomData={setNewRoomData}
                                roomData={newRoomData}
                                showPassModal={showPassModal}
                              />
                            ) : <Modal
                              isFull
                              identifier='travelers'
                              title="Rooms and Guests"
                              onClose={() => setShowPassModal(false)}
                              show={showPassModal}
                            >
                              <div className='pb-6'>
                                <PassengerModal setRoomData={setNewRoomData} roomData={newRoomData}
                                  showPassModal={showPassModal} />
                              </div>
                              <div className='fixed bottom-4 left-0 w-full flex items-center justify-center'>
                                <Button
                                  color='secondary'
                                  radius='rounded-full'
                                  onClick={() => setShowPassModal(false)}
                                  className="flex  items-center w-11/12 justify-center gap-1 "
                                >
                                  <span className=" flex flex-row gap-1.5">
                                    Done
                                  </span>
                                </Button>
                              </div>
                            </Modal>}
                        </div>
                      </div>
                    }

                  </div>
                </div>}

              <div className=" flex-row items-center gap-2 flex mt-1.5 md:mt-0">
                <div className='flex w-full items-center gap-2 top-1 h-[54px] right-1.5'>
                  {activeTab === 'hotels' &&
                    <Button
                      size='large'
                      onClick={() => {
                        onSubmitHotelSearch();
                        setSubmitType("hotels");
                      }}
                      color={buttonColor}
                      isLoading={isSubmiting || isSearchingHotels}
                      disabled={isSubmiting || isSearchingHotels}
                      className="!rounded-full flex items-center justify-center w-full md:w-fit md:!rounded-2xl"
                    >

                      <FontAwesomeIcon size='lg' icon={faSearch} />
                      <span className=''> Search  </span>

                    </Button>}
                  {activeTab === 'cities' && (
                    <Button
                      size='large'
                      onClick={onSubmitCities}
                      color={buttonColor}
                      disabled={isSubmiting}
                      className="!rounded-full flex items-center justify-center w-full md:w-fit md:!rounded-2xl"
                    >
                      {isSubmiting && submitType === "cities" ?
                        <div role="status">
                          <svg aria-hidden="true" className="inline w-6 h-6 text-gray-200 animate-spin  fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                          </svg>
                          <span className="sr-only">Loading...</span>
                        </div>
                        :
                        <>
                          <FontAwesomeIcon className='w-5 ' size='lg' icon={faSearch} />
                          <span className='inline-block'> Search </span>
                        </>
                      }
                    </Button>
                  )}
                  {activeTab === 'attractions' && (
                    <Button
                      size='large'
                      onClick={onSubmitAttractions}
                      color={buttonColor}
                      disabled={isSubmiting}
                      className="!rounded-full flex items-center justify-center w-full md:w-fit md:!rounded-2xl"
                    >
                      {isSubmiting && submitType === "attractions" ?
                        <div role="status">
                          <svg aria-hidden="true" className="inline w-6 h-6 text-gray-200 animate-spin  fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                          </svg>
                          <span className="sr-only">Loading...</span>
                        </div>
                        :
                        <>
                          <FontAwesomeIcon className='w-5 ' size='lg' icon={faSearch} />
                          <span className='inline-block'> Search </span>
                        </>
                      }
                    </Button>
                  )}
                </div>

              </div>
            </>}
        </div>


        {(errors.city || errors.country) && <div className='flex flex-col gap-2 absolute top-full text-sm text-primary-600 py-1 px-4'>
          <div className=''>
            {errors.city && <span> Oops! Looks like you forgot to choose a destination. Please enter a city to continue.</span>}
          </div>
          {activeTab === 'hotels' && <div className=''>
            {errors.country && <span> {errors.country}</span>}
          </div>}
        </div>}
      </div>

      {/* <Modal isFull title='Select date' identifier='date-select' onClose={()=> {}} show >
  <div>
  
  </div>
        </Modal> */}
    </>
  );
};

export default SearchBar
